import { observer } from "mobx-react-lite";
import { enhancedContentSourceLocation } from "../../../lib/ContentSource";
import { ReportSection, ReportSectionHeader, Literal, IndentedBlock, ReportSubSectionHeader, InferredTypeNameBlock, InferredTypeName, SearchDetails } from "../common-styles";
import { RecordingViewState } from "../RecordingViewState";
import { SearchResultDetailsView } from "./SearchResultDetailsView";



export const SearchReportByDestinationView = observer(
	({ recordingViewState }: { recordingViewState: RecordingViewState; }
	) => {
		return (<>
			{recordingViewState.searchState.searchResultsByDestinationDomain.map(
				({ destinationRegisteredDomain, sources }) => sources.map(({ sourceRegisteredDomain, searchTerms }) => (
					<ReportSection key={`${destinationRegisteredDomain}\0${sourceRegisteredDomain}`}>
						<ReportSectionHeader>
							<Literal>{destinationRegisteredDomain}&nbsp;⟵&nbsp;{sourceRegisteredDomain}</Literal>
						</ReportSectionHeader>{searchTerms.map(({ originalSearchTerm, encodings, inferredTypeNames }) => (
							<IndentedBlock key={originalSearchTerm}>
								<ReportSubSectionHeader><Literal>{originalSearchTerm}</Literal></ReportSubSectionHeader>
								{inferredTypeNames.length === 0 ? null : (
									<InferredTypeNameBlock>
										{inferredTypeNames.map( (inferredTypeName, index) => (
											<span key={inferredTypeName}>
												{index === 0 ? null : (<span>,&#32;</span>)}
												<InferredTypeName>{inferredTypeName}</InferredTypeName>
											</span>
										))}
									</InferredTypeNameBlock>
								)}
								{encodings.map(({ encodingString, eventsAndResults }) => (
									<IndentedBlock key={encodingString}>
										<SearchDetails key={encodingString}>
											<summary><Literal>{encodingString}</Literal>&#32;found at:</summary>
											{eventsAndResults.map(({ event, searchResult }) => (
												<SearchResultDetailsView
													key={`${event.eventIndex}\0${searchResult.encodedSearchTerm}\0${searchResult.position}\0${enhancedContentSourceLocation(searchResult)}`}
													displayJson={recordingViewState.setObjectToDisplayAsJson}
													{...{ event, searchResult }} />
											))}
										</SearchDetails>
									</IndentedBlock>
								))}
							</IndentedBlock>
						))}
					</ReportSection>
				))
			).flat()}</>
		);
	});
